// extracted by mini-css-extract-plugin
export default {"grid_item_box_container":"grid-item-box_grid_item_box_container__Xui+p","active":"grid-item-box_active__i05iQ"};